import { Phone, Mail, MapPin } from "lucide-react";
import { LOGO_URL, CONTACT } from "../lib/data";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-navy-deep text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Insafe" className="h-14 w-14 object-contain bg-white rounded-md p-1" />
            <div>
              <div className="font-heading font-bold text-2xl tracking-tight">INSAFE Services</div>
              <div className="font-script text-safety text-lg -mt-1">Life Is Precious</div>
            </div>
          </div>
          <p className="mt-6 text-steel max-w-md leading-relaxed">
            ISO-certified industrial safety consulting — safety audits, risk assessments,
            statutory compliance, fire safety evaluations and engineering advisory across India.
          </p>
        </div>

        <div>
          <div className="kicker !text-safety">Explore</div>
          <ul className="mt-4 space-y-2 font-body">
            <li><a href="#home" className="text-steel hover:text-white">Home</a></li>
            <li><a href="#services" className="text-steel hover:text-white">Services</a></li>
            <li><a href="#industries" className="text-steel hover:text-white">Industries</a></li>
            <li><a href="#about" className="text-steel hover:text-white">About Us</a></li>
            <li><a href="#contact" className="text-steel hover:text-white">Contact</a></li>
          </ul>
        </div>

        <div>
          <div className="kicker !text-safety">Reach Us</div>
          <ul className="mt-4 space-y-3 text-steel">
            <li className="flex items-start gap-3"><Phone className="h-4 w-4 mt-1 text-safety" /><a href={`tel:+91${CONTACT.phone}`} className="hover:text-white">+91 {CONTACT.phone}</a></li>
            <li className="flex items-start gap-3"><Mail className="h-4 w-4 mt-1 text-safety" /><a href={`mailto:${CONTACT.email}`} className="hover:text-white break-all">{CONTACT.email}</a></li>
            <li className="flex items-start gap-3"><MapPin className="h-4 w-4 mt-1 text-safety flex-shrink-0" /><span>{CONTACT.address}</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col md:flex-row justify-between gap-2 text-sm text-steel">
          <div>© {new Date().getFullYear()} Insafe Services Pvt. Ltd. All rights reserved.</div>
          <div className="font-script text-safety text-base">Safety. Compliance. Confidence.</div>
        </div>
      </div>
    </footer>
  );
}
